/***
 * Used to suppress all console log messages in the production environment
 * From: https://dev.to/rajeshroyal/reactjs-disable-consolelog-in-production-and-staging-3l38 
 * See Root.js for example
 * Usage:
 * if (process.env.NODE_ENV === 'production') {
     GlobalDebug(false, true);
   }
 */
export const GlobalDebug = (function () {
  // console.log('global debug called');
    var savedConsole = console;
    /**
    * @param {boolean} debugOn
    * @param {boolean} suppressAll
    */
    return function (debugOn, suppressAll) {
      var suppress = suppressAll || false;
      if (debugOn === false) {
        // supress the default console functionality
        console = {};
        console.log = function () {};
        // supress all type of consoles
        if (suppress) {
          console.info = function () {};
          console.warn = function () {};
          // console.error = savedConsole.error;
          console.error = function () {};
          console.table = function () {};
          console.group = function () {};
          console.groupEnd = function () {};
        } else {
          console.info = savedConsole.info;
          console.warn = savedConsole.warn;
          console.error = savedConsole.error;
          console.table = savedConsole.table;
          console.group = savedConsole.table;
          console.groupEnd = savedConsole.table;
        }
      } else {
        console = savedConsole;
      }
    };
  })();
  